export default __webpack_public_path__ + "static/beatbugs-2-b-3f1041a8846f9b20c29571989b7cf530.webp";